import { render, staticRenderFns } from "./Signage.vue?vue&type=template&id=06e74aa4&"
import script from "./Signage.vue?vue&type=script&lang=js&"
export * from "./Signage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports